import { useState, useRef } from "react";
import Config from "../../Config";

import img_ok from "../../input_check.png";
import img_error from "../../input_error.png";

import InputText from "../../helpers/InputText";

import edit from "../../edit.png";
import trash from "../../trash.png";
import cal from "../../cal.png";
import calw from "../../calw.png";
import goclose2 from "../../goclose2.png";
import zoom from "../../zoom.png";

import PlTitle from "../../elements/PlTitle";
import InputPagger from "../../helpers/InputPagger";

 
//import KidNew from "./KidNew";
//import GroupEdit from "./GroupEdit";

import icoArrow from '../../Down_Arrow_3_.png'
import gochat from "../../gochat.png";


import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputCombo from "../../helpers/InputCombo";
import InputLegend from "../../helpers/InputLegend";
import InputComboGrupaE from "../../helpers/InputComboGrupaE";
import LayetteShow from "./LayetteShow.js";
import LayetteNew from "./LayetteNew.js";

import QuickChat from "../msgE/QuickChat";
import SortBy from "../../helpers/SortBy";
import MenuTable from "../../helpers/MenuTable";
//import KidDeleteMass from "./KidDeleteMass";


function Layette(props)
{

    var cData = Config.getFromBuffer(Config.cache_grups_emps,3600, props.userData );
    
    const [gr, setGr] = useState(cData);

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({   
        d_imie_nazwisko:  props.mainView.readFilter('d_imie_nazwisko',''),
        r_imie_nazwisko:  props.mainView.readFilter('r_imie_nazwisko',''), 
        p_grupa_id: props.mainView.readFilter('p_grupa_id','_x_'),
        zrealizowano: props.mainView.readFilter('zrealizowano','0'),

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
    });
    const [tab, setTab] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);
    const [selectedLayette, setSelectedLayette] = useState([]);

    
    const [optionDone, setoptionDone]  = useState([
        {
            v: '_x_',
            title: ' - - - '
        },
        {
            v: '0',
            title: 'Nie'
        }, {
            v: '1',
            title: 'Tak'
        }
    ]
    );
    
    const tabRef = useRef(0); //do druku

    

    

    var defView =  {
        v:'list',
        id: -1
    } ;

    if(props.mainView.idSelected == -2)
    {
        defView =  {
            v:'new',
            id: -1
        } ;
    }

    const [view, setView] = useState ( defView);


    const getGr = () => {
       
 
        props.mainView.setProgress(-2);
    
       
    
        fetch( Config.url + '/rest_v1_employessModule,gr', {
            method: 'POST', 
            body: JSON.stringify({}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 
    
                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setGr(res.result);      
                        
                        Config.setToBuffer(Config.cache_grups, res.result, props.userData);
                                
                    }
    
            } )
            .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
            });
                   
    
            return false;
    }

    

    

    if( gr == null ||  gr.length == 0 )
    {
            getGr();
            
            return <div></div>;                 
            
    }



    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_employessModule,layette', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            


                        var newSelector = [];

                        res.result.forEach( (item) => {
                            newSelector.push({
                                id: item.id,
                                title: item.imie  + "  " + item.nazwisko,
                                selected: 0,
                            });
                        } )

                        setSelectedLayette(newSelector);


                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }
    
    const changeStatus = () => {
       
 
        props.mainView.setProgress(-2);

        var selected = selectedLayette.filter(selectedLayette => selectedLayette.selected === 1)

        let send_data = {
            selected: selected
        };

        fetch( Config.url + '/rest_v1_employessModule,change_layette_status', {
            method: 'POST', 
            body: JSON.stringify(send_data), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        getTab();


                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    const valChangeListener = (filedName, val, correct, msg) => {

        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        
        var modX = val.length % 3;
        if(  val.length == 0 || modX == 0 || msg =='combo')
        setTab(null);  

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
        //console.log("goNext");    
        setTab(null);    
    }


    const filterClear = () => {

        props.mainView.writeFilter('d_imie_nazwisko', '');
        props.mainView.writeFilter('r_imie_nazwisko', '');
        props.mainView.writeFilter('p_group_id', '_x_');
        props.mainView.writeFilter('archiwalne', '0');

        setFilterParam({ 
            d_imie_nazwisko: '', 
            r_imie_nazwisko: '',
            p_grupa_id: '_x_',
            zrealizowano:'0',
            
            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },


            limit: 50,
            page: 1,
            pages: 1,
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }

    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }


    if(tab == null)
    {
        setTab([]);
        getTab();
     

        return <div>
            ...
        </div>
    }


    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        setTab(null);
        setView( {
            v:'list',
            id: -1
        });
    }


    
    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        getTab();
    }
    
    const goDeleteOK = (id) => {
       
 
        props.mainView.setProgress(-2);

        var req = {
            id:id
        };

        fetch( Config.url + '/rest_v1_employessModule,layette_del', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Pozycja została usunięta" , "ok" , null);  
                       getTab();  
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    const goDelete = (e) => {

        var id = e.target.getAttribute("id");

        

        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć wybraną pozycje?", "yesno", (option)=>{
                        ///--------
                        if(option == "yes") goDeleteOK(id);
                        //--------
        } );
    }

    var xwindow = null;

    var is_mobile = props.mainView.isMobile();

    if(view.v == 'show')
    {
        var searchRow = null;
        for(var k=0; k<tab.length; k++)
        {
            if(tab[k].id == view.id) { searchRow = tab[k]; break; }
        }
    

        //if(is_mobile)
        //    return <KidShowM  userData={props.userData} mainView={props.mainView} row={searchRow} onBack={onBack}    />
        //else
            return <LayetteShow  userData={props.userData} mainView={props.mainView} row={searchRow} onBack={onBack}    />    
    }

    const changeSelected = (e) => {

        var id    = e.target.getAttribute('atr-id');   
        var selected = 0;

  

        if(e.target.checked) selected = 1;
    
        for(var k=0; k<selectedLayette.length; k++)
        {
            if(selectedLayette[k].id == id)  selectedLayette[k].selected = selected;
        }
    
        setSelectedLayette(  JSON.parse(JSON.stringify(selectedLayette) ) );    
    }

    const changeSelectedAll = (e) => {

    
        var id    = e.currentTarget.getAttribute('atr-id');   
            
    
        for(var k=0; k<selectedLayette.length; k++)
        {
        
            if(id==selectedLayette[k].p_grupa_id || id==0)
            {   
                
                
                var s = selectedLayette[k].selected;
                if(s == 1) {  s = 0; } else s = 1;
    
                selectedLayette[k].selected = s;
            }
            
        }
        
        setSelectedLayette(  JSON.parse(JSON.stringify(selectedLayette) ) ); 
        
    }

    if(view.v == 'new')
    {
        var selected = new Array();
    
        tab.forEach(dziecko => {
            
            
            if(dziecko.id==view.id) { 
                
                var dziecko_data = [];

                dziecko_data.id=dziecko.id;
                dziecko_data.imie=dziecko.imie;
                dziecko_data.nazwisko=dziecko.nazwisko;
                
                selected.push( dziecko );
            }
            

        });
            //if(is_mobile)
            //    return <KidShowM  userData={props.userData} mainView={props.mainView} row={searchRow} onBack={onBack}    />
            //else
                return <LayetteNew  userData={props.userData} mainView={props.mainView} odbiorcy={selected} onBack={onBack}    />    
    }

    var selected = selectedLayette.filter(selectedLayette => selectedLayette.selected === 1);
    
    var table = '';    
   
    
        table = (<div>

          

            <div className="table_widget">
                <div className="btn" onClick={changeView} v="new" id="-1"  > Dodaj wyprawkę</div>
                {selected.length>0 && 
                    <div className="btn" onClick={changeStatus} > Oznacz jako zrealizowane</div>
                }

                {selected.length===0 && 
                    <div className="btn btn_disabled"  > Oznacz jako zrealizowane</div>
                }

                <InputPagger filter={filterParam}  onChange={onChangePagger}  />
            </div>


            <table className="table" ref={tabRef}>
                                        <thead>
                                            <tr className="header">
                                                <td className="td_left">LP</td>
                                                <td className="link_normal" onClick={changeSelectedAll}>Z</td>
                                                <td>Dziecko</td>  
                                                <td>Grupa</td>  
                                                <td>Treść</td>    
                                                <td>Kto dodał</td>  
                                                <td>Data dodania</td>  
                                                <td>Data dostarczenia</td>  
                                                <td className="td_right">Zrealizowano</td>  
                                                <td className="td_option"> </td>
                                                
                                          
                                              
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                tab.map( (row, ix) => {

                                                    var cls = "";
                                                    if(row.archiwalne == '1') cls = "color_deleted";


                                                    var zrealizowano = "";

                                                    var data_dostarczenia = row.data_dostarczenia;

                                                    if(data_dostarczenia=='0000-00-00 00:00:00') data_dostarczenia = '';

                                                    if(row.zrealizowano==0) zrealizowano=img_error; else zrealizowano=img_ok;

                                                    var isChecked = '';

                                                    for(var s=0; s<selectedLayette.length; s++)
                                                    {
                                                        if( selectedLayette[s].id == row.id &&  selectedLayette[s].selected === 1) isChecked = "checked";
                                                    }   
                                                  
                                                        var rowStyle = " row ";
                                                        if(ix % 2 == 0 )rowStyle = " row2 ";

                                                    return (
                                                        <tr className={rowStyle + cls}  key={ix+"r"} > 

                                                            <td className="gocenter">{ix+1}</td>
                                                            <td className="gocenter"><input type="checkbox" atr-id={row.id} onChange={changeSelected} checked={isChecked} /> </td>
                                                            <td className="gocenter link_normal" onClick={changeView} v="show" id={row.id}>{row.imie+' '+row.nazwisko}</td>
                                                            <td className="link_normal"  onClick={changeView} v="show" id={row.id}>{row.grupa}</td>
                                                            <td  onClick={changeView} v="show" id={row.id} className="link_normal">{row.tresc}</td>
                                                            <td  className="link_normal" >{row.dodal}</td>
                                                            <td  className="link_normal gocenter" >{row.data_dodania}</td>
                                                            <td  className="link_normal gocenter" >{data_dostarczenia}</td>
                                                            <td  className="link_normal gocenter" ><img src={zrealizowano} ></img></td>
                                                    
                             
                                                            <MenuTable>
                                                                        <ul>
                                                                            <li  onClick={changeView} v="show" id={row.id}  >edytuj</li>
                                                                            <li  onClick={goDelete} v="show" id={row.id}  >usuń</li>
                                                                        </ul>                                                               
                                                            </MenuTable>  

                                                        </tr>  
                                                    )
                                                } )
                                            }

                                        </tbody>
                                </table>
        </div>)   
        

    return (

        <div className="view_content">

            {xwindow}

           


            <div className="table_filter mobile_filters">
                            <div className="filter_controll">   
                                <label>Grupa: </label>                             
                                <InputComboGrupaE   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id}   valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Archiwalne: "}   />
                            </div> 

                            <div className="filter_controll">   
                                <label>Zrealizowane: </label>                             
                                <InputCombo  userData={props.userData}  items={optionDone} mainView={props.mainView}  value={filterParam.zrealizowano}   valChange={valChangeListener} goNext={goNextNew} name="zrealizowano" placeholder={"Archiwalne: "}   />
                            </div>

               
                           <div className="filter_controll">   
                                <label>Dziecko: </label>                             
                                <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                            </div>  
 
                            <div className="filter_controll">   
                                <label>Treść: </label>                             
                                <InputTextAlpha   userData={props.userData} value={filterParam.r_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="tresc" placeholder={"Treść: "}   />
                            </div> 


                            <div className="filter_btn">
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                            </div>
                            
            </div>
            


            <div className="bg_center">
                    {table}        
            </div>


        </div>

    )

}

export default Layette;